export const getMissions = async (token) => {
    try {
        const response = await fetch(`https://blue-moon-app-backend.vercel.app/mission`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            const missions = data.missions;
            return missions;
        } else {
            throw new Error('Failed to fetch missions');
        }
    } catch (error) {
        console.error('Error in getMissions:', error);
    }
}